import React, { useState } from "react";
import './style.css'
import axios from "axios";
import conf from '../../conf'

const ResultItem = (props)=>{
     const { title, image, date, _id } = props.ele;
     const [isDelete, setDelete] = useState(false);
     const [isSending, setSending] = useState(false);

     const onDelete = async () =>{
          setSending(true);
          try{
               await axios.delete(conf.serverAddress + "admin/result", {
                    data: {id: _id},
                    headers: {"Authorization" : `Bearer ${document.cookie.split("=")[1]}`}
               });
               setDelete(true);
          }
          catch(e){
               setSending(false);
          }
     }

     if(isDelete) return null;
     return(
          <tr>
               <td>{props.id}</td>
               <td>{ title }</td>
               <td>{ new Date(date).toDateString() }</td>
               <td><a href={image} style={{cursor: isSending ? "wait" : "pointer"}} className="badge badge-gradient-success">View Image</a></td>
               <td><label onClick={onDelete} style={{cursor: isSending ? "wait" : "pointer"}} className="badge badge-gradient-danger">Delete</label></td>
          </tr>
     );
}

export default ResultItem;